import { useUserIdentity } from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import { useFlagsCombination } from '@src/utility/useFlagsCombination';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

interface SnapGuideContainerProps {
  $isVisible: boolean;
}

const SnapGuideContainer = styled.div<SnapGuideContainerProps>`
  position: absolute;
  top: 0;
  height: 100%;
  width: 2px;
  background-color: rgba(255, 0, 0, 0.7);
  pointer-events: none;
  z-index: 10;
  display: ${(props: SnapGuideContainerProps) =>
    props.$isVisible ? 'block' : 'none'};
`;

export const SnapGuide: React.FC = observer(() => {
  const { isSnapGuideVisible, snapGuideTime, timelineScale } =
    useVideoCreatorStore();

  const snapGuidePosition = snapGuideTime * timelineScale + 14;
  const { enableTimelineSnapGuide } = useFlagsCombination(
    useUserIdentity().currentRole,
  );

  return (
    <>
      {enableTimelineSnapGuide && (
        <SnapGuideContainer
          $isVisible={isSnapGuideVisible}
          style={{ left: `${snapGuidePosition}px` }}
        />
      )}
    </>
  );
});
